import { CLOUDINARY_BASE_URL } from "../config/cloudinary";

const img = (path) => `${CLOUDINARY_BASE_URL}${path}`;

/**
 * 言語に関係なく固定の情報
 */
const activityCommon = {
  sup: {
    id: "sup",
    emoji: "🌊",
    time: "10:00",
    image: img("v1784734130/DJI_20260722152642_0033_D_tb9qki.webp"),
    pricePerPerson: 12000,
    soloPricePerPerson: 15000,
  },
  uni: {
    id: "uni",
    emoji: "🏝️",
    time: "14:00",
    image: img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg"),
    pricePerPerson: 7000,
    unavailable: true,
  },
  star: {
    id: "star",
    emoji: "✨",
    time: "20:00",
    image: img("v1784187848/image_bdd0ur.webp"),
    pricePerPerson: 8000,
  },
  sunset: {
    id: "sunset",
    emoji: "🌅",
    time: "19:00",
    image: img("v1782544103/%EF%BC%99_nk1ewv.jpg"),
    pricePerPerson: 10000,
  },
};

/**
 * 表示順
 */
const activityOrder = ["sup", "uni", "star", "sunset"];

/**
 * オプションカード用テキスト
 */
const activityTexts = {
  JP: {
    sup: {
      title: "秘境SUP",
      shortText: "人がいない秘境スポットでSUP体験",
      scheduleTitle: "秘境SUP",
      scheduleText: "透き通る海でSUPを満喫。",
    },
    uni: {
      title: "ユニの浜SUP",
      shortText: "幻の砂浜・ユニの浜へSUPで向かう特別体験",
      scheduleTitle: "ユニの浜SUP",
      scheduleText:
        "潮が引いた時だけ現れる幻の砂浜、ユニの浜をSUPで目指します。",
    },
    star: {
      title: "星空撮影",
      shortText: "満天の星空の下で特別な一枚を",
      scheduleTitle: "星空撮影",
      scheduleText: "その日の天候によってお断りさせていただく場合があります",
    },
    sunset: {
      title: "サンセットSUP",
      shortText: "宮古島の美しい夕日をベストロケーションで独り占め",
      scheduleTitle: "サンセットSUP",
      scheduleText:
        "夕日が沈む19:00前後に合わせて、サンセットSUPと撮影を行います。",
    },
  },

  EN: {
    sup: {
      title: "Hidden SUP",
      shortText: "SUP experience at a quiet hidden spot",
      scheduleTitle: "Hidden SUP",
      scheduleText: "Enjoy SUP in calm, crystal-clear water.",
    },
    uni: {
      title: "Yuni Beach SUP",
      shortText: "SUP to the hidden sandbar known as Yuni Beach",
      scheduleTitle: "Yuni Beach SUP",
      scheduleText:
        "Paddle to Yuni Beach, a beautiful sandbar that appears only when the tide is low.",
    },
    star: {
      title: "Starry Sky Photo",
      shortText: "A special photo under the stars",
      scheduleTitle: "Starry Sky Photo",
      scheduleText: "Capture a special moment under the beautiful night sky.",
    },
    sunset: {
      title: "Sunset SUP",
      shortText: "Enjoy Miyako Island’s sunset from the best location",
      scheduleTitle: "Sunset SUP",
      scheduleText:
        "Enjoy sunset SUP and shooting around 7:00 PM, timed with the sunset.",
    },
  },

  中文: {
    sup: {
      title: "秘境 SUP",
      shortText: "在人少的秘境海域体验 SUP",
      scheduleTitle: "秘境 SUP",
      scheduleText: "在清澈透明的大海中享受 SUP。",
    },
    uni: {
      title: "Yuni 海滩 SUP",
      shortText: "乘 SUP 前往退潮时出现的梦幻沙滩",
      scheduleTitle: "Yuni 海滩 SUP",
      scheduleText: "乘 SUP 前往只有退潮时才会出现的梦幻沙滩 Yuni 海滩。",
    },
    star: {
      title: "星空拍摄",
      shortText: "在满天星空下拍摄特别的一张照片",
      scheduleTitle: "星空拍摄",
      scheduleText: "以满天星空为背景，拍摄特别的一张照片。",
    },
    sunset: {
      title: "日落 SUP",
      shortText: "在最佳位置欣赏宫古岛美丽的日落",
      scheduleTitle: "日落 SUP",
      scheduleText: "配合19:00左右的日落时间，进行日落 SUP 和拍摄。",
    },
  },

  한국어: {
    sup: {
      title: "숨겨진 SUP",
      shortText: "사람이 적은 비밀 스팟에서 SUP 체험",
      scheduleTitle: "숨겨진 SUP",
      scheduleText: "투명한 바다에서 SUP를 즐깁니다.",
    },
    uni: {
      title: "유니 해변 SUP",
      shortText: "썰물 때만 나타나는 모래섬으로 향하는 SUP 체험",
      scheduleTitle: "유니 해변 SUP",
      scheduleText:
        "썰물 때만 나타나는 환상적인 모래섬, 유니 해변을 SUP로 향합니다.",
    },
    star: {
      title: "별하늘 촬영",
      shortText: "가득한 별빛 아래 특별한 한 장",
      scheduleTitle: "별하늘 촬영",
      scheduleText: "아름다운 별하늘을 배경으로 특별한 사진을 촬영합니다.",
    },
    sunset: {
      title: "선셋 SUP",
      shortText: "최고의 장소에서 아름다운 노을 감상",
      scheduleTitle: "선셋 SUP",
      scheduleText: "19:00 전후 노을 시간에 맞춰 선셋 SUP와 촬영을 진행합니다.",
    },
  },
};

export const scheduleActivities = Object.fromEntries(
  Object.entries(activityTexts).map(([lang, texts]) => [
    lang,
    activityOrder.map((id) => ({
      ...activityCommon[id],
      ...texts[id],
    })),
  ]),
);

/**
 * スケジュール用の固定情報
 */
const scheduleCommon = {
  pickup: {
    id: "pickup",
    time: "9:00",
    image: img("v1784191145/image8_lcviao.webp"),
    tag: "START",
  },

  irabu: {
    id: "irabu",
    time: "10:00",
    image: img("v1783928437/DJI_20260707115907_0008_D_xag4ot.webp"),
    tag: "PHOTO",
  },

  sup: {
    id: "schedule-sup",
    time: "11:00",
    image: img("v1785004077/DJI_20260707125430_0025_D_small_r4mnrd.jpg"),
    tag: "SUP",
  },

  lunch: {
    id: "lunch",
    time: "12:00",
    image: img("v1784190790/image7_h9rafx.webp"),
    tag: "LUNCH",
  },

  uni: {
    id: "schedule-uni",
    time: "14:00",
    image: img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg"),
    tag: "SUP",
  },

  island: {
    id: "island",
    time: "13:30",
    image: img("v1784191325/image9_vwojco.webp"),
    tag: "PHOTO",
  },

  dayBreak: {
    id: "day-break",
    time: "15:00",
    image: img("v1782544103/%EF%BC%99_nk1ewv.jpg"),
    tag: "BREAK",
  },

  repickupSunset: {
    id: "repickup-sunset",
    time: "18:15",
    image: img("v1782544103/%EF%BC%99_nk1ewv.jpg"),
    tag: "PICK UP",
  },

  sunset: {
    id: "schedule-sunset",
    time: "19:00",
    image: img("v1782544103/%EF%BC%99_nk1ewv.jpg"),
    tag: "SUNSET",
  },

  repickupStar: {
    id: "repickup-star",
    time: "19:30",
    // image: img('v1784187848/image_bdd0ur.webp'),
    tag: "PICK UP",
  },

  star: {
    id: "schedule-star",
    time: "20:00",
    image: img("v1784187848/image_bdd0ur.webp"),
    tag: "STAR",
  },

  finishDay: {
    id: "finish-day",
    time: "15:00",
    image: img("v1784190790/image7_h9rafx.webp"),
    tag: "FINISH",
  },

  finishSunset: {
    id: "finish-sunset",
    time: "20:15ごろ",
    image: img("v1782544103/%EF%BC%99_nk1ewv.jpg"),
    tag: "FINISH",
  },

  finishNight: {
    id: "finish-night",
    time: "21:30ごろ",
    // image: img('v1782578020/1_vohkmm.jpg'),
    tag: "FINISH",
  },
};

/**
 * スケジュール用テキスト
 */
const scheduleTexts = {
  JP: {
    pickup: {
      scheduleTitle: "お迎え",
      scheduleText: "ご宿泊先までお迎え",
    },
    irabu: {
      scheduleTitle: "伊良部島 絶景スポット撮影",
      scheduleText:
        "伊良部島の秘境や貸切ビーチ、絶景ポイントで、写真・動画を撮影",
    },
    sup: {
      scheduleTitle: "秘境SUP",
      scheduleText:
        "人の少ない静かな海でSUP体験。ドローン撮影・一眼カメラ撮影も行います。",
    },
    lunch: {
      scheduleTitle: "ランチ・自由時間",
      scheduleText: "ランチスポットへご案内。ご希望に合わせて変更も可能です。",
    },
    uni: {
      scheduleTitle: "ユニの浜SUP",
      scheduleText:
        "潮が引いた時だけ現れる幻の砂浜、ユニの浜をSUPで目指します。",
    },
    island: {
      scheduleTitle: "来間島など別の島へご案内",
      scheduleText:
        "来間島など、その日の天候や光の入り方に合わせて別の島へご案内し、撮影を行います。",
    },
    dayBreak: {
      scheduleTitle: "一時解散",
      scheduleText: "夕方・夜の撮影がある場合は、再度お迎えに伺います。",
    },
    repickupSunset: {
      scheduleTitle: "お迎え・サンセットポイントへ移動",
      scheduleText:
        "夕日の時間に合わせて再度お迎えし、サンセットSUPのポイントへ向かいます。",
    },
    sunset: {
      scheduleTitle: "サンセットSUP",
      scheduleText:
        "19:00前後のサンセットタイムに合わせて、SUP体験と写真・動画撮影を行います。",
    },
    repickupStar: {
      scheduleTitle: "お迎え",
      scheduleText:
        "夜の撮影に合わせて再度お迎えし、星空が綺麗に見えるスポットへ向かいます。",
    },
    star: {
      scheduleTitle: "星空撮影",
      scheduleText: "天候を見ながら、星が綺麗に見える場所へご案内します。",
    },
    finishDay: {
      scheduleTitle: "解散",
      scheduleText: "ツアー終了。ご希望に応じてご宿泊先までお送りします。",
    },
    finishSunset: {
      scheduleTitle: "ツアー終了",
      scheduleText: "サンセット撮影後、ご宿泊先へお送りしてツアー終了。",
    },
    finishNight: {
      scheduleTitle: "ツアー終了",
      scheduleText: "星空撮影後、ご宿泊先へお送りしてツアー終了。",
    },
  },

  EN: {
    pickup: {
      scheduleTitle: "Hotel Pick-up",
      scheduleText: "We will pick you up at your hotel.",
    },
    irabu: {
      scheduleTitle: "Irabu Island Scenic Photo Spot",
      scheduleText:
        "Photo and video shooting at scenic spots overlooking the beautiful ocean and bridges of Irabu Island.",
    },
    sup: {
      scheduleTitle: "Hidden SUP",
      scheduleText:
        "Enjoy SUP at a quiet hidden beach with drone and camera shooting included.",
    },
    lunch: {
      scheduleTitle: "Lunch",
      scheduleText:
        "We will take you to a local lunch spot. The restaurant can be adjusted depending on your preference.",
    },
    uni: {
      scheduleTitle: "Yuni Beach SUP",
      scheduleText:
        "Paddle to Yuni Beach, a beautiful sandbar that appears only when the tide is low.",
    },
    island: {
      scheduleTitle: "Another Island Photo Stop",
      scheduleText:
        "Depending on the weather and light, we will guide you to another island such as Kurima Island for more shooting.",
    },
    dayBreak: {
      scheduleTitle: "Break / Free Time",
      scheduleText:
        "The daytime shooting ends here. If you selected sunset or starry sky shooting, we will pick you up again later.",
    },
    repickupSunset: {
      scheduleTitle: "Pick-up Again for Sunset",
      scheduleText:
        "We will pick you up again and head to the best location for sunset SUP.",
    },
    sunset: {
      scheduleTitle: "Sunset SUP",
      scheduleText:
        "Enjoy SUP and photo/video shooting around 7:00 PM, timed with the sunset.",
    },
    repickupStar: {
      scheduleTitle: "Pick-up Again for Starry Sky",
      scheduleText:
        "We will pick you up again and head to a spot where the stars can be seen clearly.",
    },
    star: {
      scheduleTitle: "Starry Sky Photo",
      scheduleText:
        "Starry sky shooting starts from 8:00 PM. The location may change depending on the weather.",
    },
    finishDay: {
      scheduleTitle: "Tour Finish",
      scheduleText:
        "The tour ends here. Drop-off at your hotel is available upon request.",
    },
    finishSunset: {
      scheduleTitle: "Tour Finish",
      scheduleText:
        "After sunset shooting, we will take you back to your hotel.",
    },
    finishNight: {
      scheduleTitle: "Tour Finish",
      scheduleText:
        "After starry sky shooting, we will take you back to your hotel.",
    },
  },

  中文: {
    pickup: {
      scheduleTitle: "酒店接送",
      scheduleText: "前往您的酒店接您。",
    },
    irabu: {
      scheduleTitle: "伊良部岛绝景拍摄",
      scheduleText:
        "在可以欣赏美丽大海与大桥的伊良部岛绝景地点拍摄照片和视频。",
    },
    sup: {
      scheduleTitle: "秘境 SUP",
      scheduleText: "在人少安静的海域体验 SUP，并进行无人机和相机拍摄。",
    },
    lunch: {
      scheduleTitle: "午餐",
      scheduleText:
        "带您前往具有宫古岛特色的午餐地点，也可以根据您的喜好调整餐厅。",
    },
    uni: {
      scheduleTitle: "Yuni 海滩 SUP",
      scheduleText: "乘 SUP 前往只有退潮时才会出现的梦幻沙滩 Yuni 海滩。",
    },
    island: {
      scheduleTitle: "前往来间岛等其他岛屿拍摄",
      scheduleText: "根据当天的天气和光线，带您前往来间岛等其他岛屿继续拍摄。",
    },
    dayBreak: {
      scheduleTitle: "暂时解散 / 休息",
      scheduleText:
        "白天拍摄到这里暂时结束。如选择了日落或星空拍摄，将会再次接您。",
    },
    repickupSunset: {
      scheduleTitle: "再次接送 / 前往日落地点",
      scheduleText: "配合日落时间再次接您，前往适合日落 SUP 的地点。",
    },
    sunset: {
      scheduleTitle: "日落 SUP",
      scheduleText: "配合19:00左右的日落时间，进行 SUP 体验和照片、视频拍摄。",
    },
    repickupStar: {
      scheduleTitle: "再次接送 / 前往星空地点",
      scheduleText: "配合夜间拍摄时间再次接您，前往星空清晰可见的地点。",
    },
    star: {
      scheduleTitle: "星空拍摄",
      scheduleText: "20:00开始星空拍摄。会根据天气情况选择最适合的拍摄地点。",
    },
    finishDay: {
      scheduleTitle: "行程结束",
      scheduleText: "行程到这里结束。也可以根据需要送您返回酒店。",
    },
    finishSunset: {
      scheduleTitle: "行程结束",
      scheduleText: "日落拍摄结束后，送您返回酒店。",
    },
    finishNight: {
      scheduleTitle: "行程结束",
      scheduleText: "星空拍摄结束后，送您返回酒店。",
    },
  },

  한국어: {
    pickup: {
      scheduleTitle: "호텔 픽업",
      scheduleText: "숙소까지 픽업해 드립니다.",
    },
    irabu: {
      scheduleTitle: "이라부섬 절경 스팟 촬영",
      scheduleText:
        "이라부섬의 아름다운 바다와 다리를 볼 수 있는 절경 스팟에서 사진과 영상을 촬영합니다.",
    },
    sup: {
      scheduleTitle: "숨겨진 SUP",
      scheduleText:
        "사람이 적은 조용한 바다에서 SUP를 즐기고 드론과 카메라 촬영도 함께 진행합니다.",
    },
    lunch: {
      scheduleTitle: "점심",
      scheduleText:
        "미야코지마다운 점심 장소로 안내해 드립니다. 원하시는 분위기에 맞춰 변경도 가능합니다.",
    },
    uni: {
      scheduleTitle: "유니 해변 SUP",
      scheduleText:
        "썰물 때만 나타나는 환상적인 모래섬, 유니 해변을 SUP로 향합니다.",
    },
    island: {
      scheduleTitle: "구리마섬 등 다른 섬 촬영",
      scheduleText:
        "당일 날씨와 빛의 방향에 맞춰 구리마섬 등 다른 섬으로 이동해 촬영합니다.",
    },
    dayBreak: {
      scheduleTitle: "일시 해산 / 휴식",
      scheduleText:
        "낮 촬영은 여기서 잠시 종료됩니다. 선셋 또는 별하늘 촬영이 있는 경우 다시 픽업해 드립니다.",
    },
    repickupSunset: {
      scheduleTitle: "재픽업 / 선셋 포인트 이동",
      scheduleText:
        "노을 시간에 맞춰 다시 픽업 후 선셋 SUP 포인트로 이동합니다.",
    },
    sunset: {
      scheduleTitle: "선셋 SUP",
      scheduleText:
        "19:00 전후 노을 시간에 맞춰 SUP 체험과 사진, 영상 촬영을 진행합니다.",
    },
    repickupStar: {
      scheduleTitle: "재픽업 / 별하늘 포인트 이동",
      scheduleText:
        "밤 촬영 시간에 맞춰 다시 픽업 후 별이 잘 보이는 장소로 이동합니다.",
    },
    star: {
      scheduleTitle: "별하늘 촬영",
      scheduleText:
        "20:00부터 별하늘 촬영을 진행합니다. 날씨에 따라 가장 좋은 장소로 안내합니다.",
    },
    finishDay: {
      scheduleTitle: "투어 종료",
      scheduleText: "투어가 종료됩니다. 원하시면 숙소까지 모셔다드립니다.",
    },
    finishSunset: {
      scheduleTitle: "투어 종료",
      scheduleText: "선셋 촬영 후 숙소까지 모셔다드리며 투어가 종료됩니다.",
    },
    finishNight: {
      scheduleTitle: "투어 종료",
      scheduleText: "별하늘 촬영 후 숙소까지 모셔다드리며 투어가 종료됩니다.",
    },
  },
};

const getScheduleText = (lang, id) => {
  return scheduleTexts[lang]?.[id] || scheduleTexts.JP[id];
};

const createStep = (lang, id, overrides = {}) => {
  return {
    ...scheduleCommon[id],
    ...getScheduleText(lang, id),
    ...overrides,
    time: overrides.time || scheduleCommon[id].time,
  };
};

export const createTourSchedule = (
  lang = "JP",
  selectedIds = [],
  { includeBaseTour = true } = {},
) => {
  const currentLang = scheduleTexts[lang] ? lang : "JP";
  const ids = new Set(selectedIds);

  const hasSup = ids.has("sup"); // 秘境SUP
  const hasUni = ids.has("uni"); // ユニの浜SUP
  const hasStar = ids.has("star"); // 星空撮影
  const hasSunset = ids.has("sunset"); // サンセットSUP

  const NORMAL_SUP_DURATION_MINUTES = 120; // 秘境SUP / ユニの浜SUP
  const SUNSET_SUP_DURATION_MINUTES = 60; // サンセットSUP
  const SCENIC_PHOTO_MINUTES = 120; // 絶景スポット撮影

  const toMinutes = (time) => {
    const [hour, minute] = time.split(":").map(Number);
    return hour * 60 + minute;
  };

  const toTime = (minutes) => {
    const hour = Math.floor(minutes / 60);
    const minute = minutes % 60;

    return `${hour}:${String(minute).padStart(2, "0")}`;
  };

  const addMinutes = (time, minutes) => {
    return toTime(toMinutes(time) + minutes);
  };

  const scenicSpotTexts = {
    JP: {
      scheduleTitle: "絶景スポット撮影",
      scheduleText:
        "その日の天候や光の入り方に合わせて、宮古島の絶景スポットで写真・動画を撮影します。",
    },
    EN: {
      scheduleTitle: "Scenic Photo Spot",
      scheduleText:
        "We will shoot photos and videos at a scenic spot in Miyako Island, depending on the weather and light.",
    },
    中文: {
      scheduleTitle: "绝景地点拍摄",
      scheduleText: "根据当天的天气和光线，在宫古岛的绝景地点拍摄照片和视频。",
    },
    한국어: {
      scheduleTitle: "절경 스팟 촬영",
      scheduleText:
        "당일 날씨와 빛의 방향에 맞춰 미야코지마의 절경 스팟에서 사진과 영상을 촬영합니다.",
    },
  };

  const createScenicSpotStep = (time) => {
    return createStep(currentLang, "irabu", {
      time,
      ...(scenicSpotTexts[currentLang] || scenicSpotTexts.JP),
    });
  };

  const schedule = [];

  if (!includeBaseTour) {
    const simpleSteps = [];

    if (hasSup) {
      simpleSteps.push({
        id: "sup",
        time: "11:00",
        duration: NORMAL_SUP_DURATION_MINUTES,
      });
    }

    if (hasSunset) {
      simpleSteps.push({
        id: "sunset",
        time: "19:00",
        duration: SUNSET_SUP_DURATION_MINUTES,
      });
    }

    if (hasStar) {
      simpleSteps.push({
        id: "star",
        time: "20:00",
        duration: 90,
      });
    }

    if (simpleSteps.length === 0) return [];

    const firstStep = simpleSteps[0];
    const pickupTime = toTime(toMinutes(firstStep.time) - 30);

    schedule.push(
      createStep(currentLang, "pickup", {
        time: pickupTime,
      }),
    );

    simpleSteps.forEach((step) => {
      schedule.push(
        createStep(currentLang, step.id, {
          time: step.time,
        }),
      );
    });

    const lastStep = simpleSteps[simpleSteps.length - 1];
    const finishTime = `${addMinutes(lastStep.time, lastStep.duration)}ごろ`;
    const finishId = hasStar
      ? "finishNight"
      : hasSunset
        ? "finishSunset"
        : "finishDay";

    schedule.push(
      createStep(currentLang, finishId, {
        time: finishTime,
      }),
    );

    return schedule;
  }

  /**
   * サンセットSUPが入っている場合
   * → 18:00 サンセットSUP開始
   * → サンセットSUPは1時間
   * → 一時解散は入れない
   * → 来間島など別の島へご案内は入れない
   * → 通常の「絶景スポット撮影」は入れる
   */
  if (hasSunset) {
    const beforeSunsetSupSteps = [];

    /**
     * ユニの浜SUPがある場合は、お迎え後すぐユニの浜SUP
     */
    if (hasUni) {
      beforeSunsetSupSteps.push("uni");
    }

    if (hasSup) {
      beforeSunsetSupSteps.push("sup");
    }

    const sunsetStartTime = "18:00";

    const totalBeforeSunsetMinutes =
      beforeSunsetSupSteps.length * NORMAL_SUP_DURATION_MINUTES +
      SCENIC_PHOTO_MINUTES;

    const firstActivityStartMinutes =
      toMinutes(sunsetStartTime) - totalBeforeSunsetMinutes;

    const pickupTime = toTime(firstActivityStartMinutes - 30);

    schedule.push(
      createStep(currentLang, "pickup", {
        time: pickupTime,
      }),
    );

    let currentMinutes = firstActivityStartMinutes;

    beforeSunsetSupSteps.forEach((stepId) => {
      schedule.push(
        createStep(currentLang, stepId, {
          time: toTime(currentMinutes),
        }),
      );

      currentMinutes += NORMAL_SUP_DURATION_MINUTES;
    });

    /**
     * サンセットSUP前の絶景スポット撮影
     */
    schedule.push(createScenicSpotStep(toTime(currentMinutes)));

    currentMinutes += SCENIC_PHOTO_MINUTES;

    /**
     * サンセットSUP
     */
    schedule.push(
      createStep(currentLang, "sunset", {
        time: sunsetStartTime,
      }),
    );

    const sunsetEndTime = addMinutes(
      sunsetStartTime,
      SUNSET_SUP_DURATION_MINUTES,
    );

    if (hasStar) {
      schedule.push(
        createStep(currentLang, "star", {
          time: "20:00",
        }),
      );

      schedule.push(
        createStep(currentLang, "finishNight", {
          time: "21:30ごろ",
        }),
      );
    } else {
      schedule.push(
        createStep(currentLang, "finishSunset", {
          time: `${addMinutes(sunsetEndTime, 30)}ごろ`,
        }),
      );
    }

    return schedule;
  }

  /**
   * サンセットSUPが入っていない通常スケジュール
   */
  schedule.push(createStep(currentLang, "pickup"));

  /**
   * ユニの浜SUPが入っている場合
   * → お迎え後すぐユニの浜SUP
   * → 所要時間2時間
   * → 来間島など別の島へご案内は入れない
   */
  if (hasUni) {
    schedule.push(
      createStep(currentLang, "uni", {
        time: "10:00",
      }),
    );

    schedule.push(
      createStep(currentLang, "lunch", {
        time: "12:30",
      }),
    );

    schedule.push(
      createStep(currentLang, "irabu", {
        time: "13:30",
      }),
    );

    if (hasSup) {
      schedule.push(
        createStep(currentLang, "sup", {
          time: "15:00",
        }),
      );
    }
  }

  /**
   * ユニの浜SUPが入っていない場合
   */
  if (!hasUni) {
    schedule.push(createStep(currentLang, "irabu"));

    if (hasSup) {
      schedule.push(
        createStep(currentLang, "sup", {
          time: "11:00",
        }),
      );

      schedule.push(
        createStep(currentLang, "lunch", {
          time: "13:30",
        }),
      );
    } else {
      schedule.push(
        createStep(currentLang, "lunch", {
          time: "12:00",
        }),
      );

      /**
       * SUP系が何も入っていない場合だけ
       * → 来間島など別の島へご案内
       */
      schedule.push(
        createStep(currentLang, "island", {
          time: "13:30",
        }),
      );
    }
  }

  let dayCloseTime = "15:00";

  if (hasUni && hasSup) {
    dayCloseTime = "17:00";
  } else if (hasUni) {
    dayCloseTime = "15:00";
  } else if (hasSup) {
    dayCloseTime = "15:00";
  }

  /**
   * 星空撮影がある場合
   * → 昼スケジュール後に一度解散
   * → 夜に再お迎えして星空撮影
   */
  if (hasStar) {
    schedule.push(
      createStep(currentLang, "dayBreak", {
        time: dayCloseTime,
      }),
    );

    schedule.push(
      createStep(currentLang, "repickupStar", {
        time: "19:30",
      }),
    );

    schedule.push(
      createStep(currentLang, "star", {
        time: "20:00",
      }),
    );

    schedule.push(createStep(currentLang, "finishNight"));

    return schedule;
  }

  schedule.push(
    createStep(currentLang, "finishDay", {
      time: dayCloseTime,
    }),
  );

  return schedule;
};

/**
 * 互換用：何も選択していない時の基本スケジュール
 */
export const defaultSchedules = Object.fromEntries(
  Object.keys(scheduleTexts).map((lang) => [
    lang,
    createTourSchedule(lang, []),
  ]),
);
